import { FC, useCallback, useEffect, useState } from "react";
import { applyFilters } from "../../../helpers/applyFilters";
import SearchArea from "./SearchArea";

interface Filter {
  key: string;
  value: string | undefined;
  setValue: (value: string | undefined) => void;
}

interface SearchAreaHandleSearchProps {
  setDataTable: (data: any) => void;
  dataTable: any[];
  filterFunction: (
    item: any,
    searchTerm: string,
    filters: Record<string, string | undefined>,
  ) => boolean;
  filters?: Filter[];
  placeholderText?: string;
  hasIcon?: boolean;
  isDisabled?: boolean;
}

const SearchAreaHandleSearch: FC<SearchAreaHandleSearchProps> = ({
  setDataTable,
  dataTable,
  filterFunction,
  filters = [],
  placeholderText,
  hasIcon,
  isDisabled = false,
}) => {
  const [originalDataTable, setOriginalDataTable] = useState<any[]>(dataTable);
  const [inputSearch, setInputSearch] = useState<string>("");

  useEffect(() => {
    setOriginalDataTable(dataTable);
  }, [dataTable]);

  const handleSearchCall = useCallback(() => {
    const filterObject = filters.reduce(
      (acc, filter) => {
        acc[filter.key] = filter.value;
        return acc;
      },
      {} as Record<string, string | undefined>,
    );

    const filteredData = applyFilters(
      originalDataTable,
      inputSearch,
      filterFunction,
      filterObject,
    );

    setDataTable(filteredData);
  }, [inputSearch, filters, originalDataTable, setDataTable, filterFunction]);

  useEffect(() => {
    handleSearchCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputSearch]);

  const handleRemoveCall = useCallback(() => {
    setInputSearch("");
  }, []);

  return (
    <SearchArea
      handleSearchCall={handleSearchCall}
      handleRemoveCall={handleRemoveCall}
      setInputSearch={setInputSearch}
      inputSearch={inputSearch}
      placeholderText={placeholderText}
      hasIcon={hasIcon}
      isDisabled={isDisabled}
    ></SearchArea>
  );
};

export default SearchAreaHandleSearch;
